module.exports = __webpack_public_path__ + "static/img/noOrder.9c7acc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/noOrder.png
// module id = E5gi
// module chunks = 1